import React from 'react';

import {type RouteConfigPath, type PathGenerationArgs} from '../routes/route-config';

/**
 * @deprecated Use generateHash instead
 */
export type NavigationFunction = (route: string | object, ...args: Array<string | object>) => string;

export interface NavigationContext {
    /**
     * @deprecated Use generateHash instead
     */
    generateUrl: NavigationFunction;
    /**
     * @deprecated Use navigateToHash instead
     */
    transitionTo: NavigationFunction;
    /**
     * @deprecated Use replaceWithHash instead
     */
    replaceWith: NavigationFunction;

    generateHash: <T extends RouteConfigPath>(...args: PathGenerationArgs<T>) => string;
    transitionToPath: <T extends RouteConfigPath>(...args: PathGenerationArgs<T>) => void;
    replaceWithPath: <T extends RouteConfigPath>(...args: PathGenerationArgs<T>) => void;
}

export const navigationContext = React.createContext<NavigationContext>({
    /**
     * @deprecated Use generateHash instead
     */
    generateUrl: () => {
        throw Error('Navigation context not correctly initialized');
    },
    /**
     * @deprecated Use transitionToPath instead
     */
    transitionTo: () => {
        throw Error('Navigation context not correctly initialized');
    },
    /**
     * @deprecated Use replaceWithPath instead
     */
    replaceWith: () => {
        throw Error('Navigation context not correctly initialized');
    },
    generateHash: () => {
        throw Error('Navigation context not correctly initialized');
    },
    transitionToPath: () => {
        throw Error('Navigation context not correctly initialized');
    },
    replaceWithPath: () => {
        throw Error('Navigation context not correctly initialized');
    },
});

const {Consumer} = navigationContext;

export const NavigationContextConsumer = Consumer;
